<template>
   <Form :ref="(e) => (refs.form = e)" layout="horizontal">
      <TemplateBuilder
              v-if="!viewOnly"
              :rowProp="data.rowProp"
              :useForm="data.useForm"
              :fields="data.fields"
              :skeleton="isLoading"
      ></TemplateBuilder>
      <div v-else-if="form?.id">
         <div v-if="form?.refLabTopic?.refLabFormula?.key === 'n c m M'">
            <div>n = {{ form.n }}</div>
            <div>c = {{ form.c }}</div>
            <div>m = {{ form.m }}</div>
            <div>M = {{ form.mUpper }}</div>
         </div>
         <div v-else-if="form?.refLabTopic?.refLabFormula?.key === 'Operator'">
            <div>
               <span v-if="form.mathSymbol">{{ form.mathSymbol }}</span>
               <span v-if="form.operatorValue">{{ form.operatorValue }}</span>
            </div>
         </div>
         <div v-else-if="form?.refLabTopic?.refLabFormula?.key === 'Accept/Reject'">
            <div v-if="form.isAccept">Accept</div>
            <div v-else>Not Accept</div>
         </div>
         <div v-else-if="form?.refLabTopic?.refLabFormula?.key === 'Detected'">
            <div v-if="form.isDetected">Detected</div>
            <div v-else>Not Detected</div>
         </div>
      </div>
   </Form>
</template>
<script>

    import { defineAsyncComponent, defineComponent, reactive } from "vue";
    import { initForm, isLoading, onClickModalOk } from "./operator-form.logic.js"
    import { state as stateApp } from "../../../../../app.logic";

    export default defineComponent({
        components: {
            TemplateBuilder: defineAsyncComponent(() => import("../../../../../components/input/template-builder/TemplateBuilder")),
        },
        props: {
            form: {},
            parent: {},
            viewOnly: { default: true },
            labTypeKey: { },
            whereTopic: { default: [] },
            visibleTopic: { default: true },
            disableTopic: { default: true },
            menuContext: { default: () => stateApp.menuContext },
        },
        methods: {},
        setup(props) {
            const data = reactive({ mathSymbolSelectItems: [{ mathSymbol: "=" }, { mathSymbol: ">" }, {  mathSymbol: "<" }, {  mathSymbol: ">=" }, {  mathSymbol: "<=" }], rowProp: { gutter: 24 } })
            const refs = reactive({ form: null });
            const callOnClickModalOk = () => onClickModalOk({ data, refs });
            initForm({ props, data, refs })
            return {
                props,
                data,
                refs,
                isLoading,
                callOnClickModalOk
            };
        }
    });
</script>
